import { HttpClient, HttpResponse } from "@angular/common/http";
import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  ErrorStateMatcher,
  MAT_DIALOG_DATA,
  MatAccordion,
  MatDialogRef,
  MatSnackBar,
  MatStepper,
} from "@angular/material";
// Import  TranslateService
import { TranslateService } from "@ngx-translate/core";
import { AssessmentAnswerInterface } from "app/assessment/models";
import { DropZoneSettings } from "app/core/dropzone-config/dropzone-config.constant";
import { MceSettings } from "app/core/mce-config/mce-editor-config.constant";
import {
  RecommendationTemplateInterface,
  RecommendationTemplateRuleInterface,
} from "app/recommendation/models";
import { AssessmentQuestionDataInterface } from "app/recommendation/models/assessment-question-data.model";
import { RecommendationService } from "app/recommendation/services/recommendation.service";
import {
  stringDecodeToHtml,
  stringEncodeToB64,
} from "app/shared/utilities/utility-methods.utility";
import { SiteSupportedLanguageInterface } from "app/site-settings/models/site-supported-language.model";
import { environment } from "environments/environment.prod";
import {
  DropzoneComponent,
  DropzoneConfigInterface,
} from "ngx-dropzone-wrapper";
import { Observable, Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

import { DefaultLanguageStringsService } from "../../../core/language/services/default-language-strings.service";
import { recommendationItemMullangInterface } from "../../models/recommendation-item-multi.model";
@Component({
  selector: "cz-recommendations-configuration-item-dialog",
  templateUrl: "./recommendations-configuration-item-dialog.component.html",
  styleUrls: ["./recommendations-configuration-item-dialog.component.scss"],
})
export class RecommendationsConfigurationItemDialogComponent
  implements OnInit, OnDestroy
{
  @ViewChild("dropzoneRef") public dropzoneRef?: DropzoneComponent;
  @ViewChild("stepper") public stepper: MatStepper;
  public showDelete: boolean = true;
  public isSaving: boolean = false;
  public addNewItem: boolean = true;
  public secondStepEnabled: boolean = false;
  public thirdStepEnabled: boolean = false;
  public mceValid: boolean = true;

  public firstFormGroup: FormGroup;
  public thirdFormGroup: FormGroup;

  public defaultPlaceHolder: string =
    "/assets/images/components/cz-assessment/section-img-upload/icon-upload.png";
  public dropzoneConfig: DropzoneConfigInterface = DropZoneSettings.default;
  public placeholderImage: string;

  public recommendation: RecommendationTemplateInterface;
  public ruleData: AssessmentQuestionDataInterface;
  public availableAnswers: AssessmentAnswerInterface[] = [];

  public tinyApiKey: string = environment.tinyMceKey;
  public editorConfig: any = MceSettings.default;
  public supportedlanguage: SiteSupportedLanguageInterface[];
  public defaultLanguage: number;
  public defLangExt: string;
  public addForm: FormGroup;
  public rows: FormArray;
  public panelOpenState: boolean = false;
  public step: number = 0;
  public isLiner: boolean = true;
  public title: string;
  public validate: ErrorStateMatcher = {
    isErrorState: (control: FormControl): any => {
      return false;
    },
  };
  @ViewChild("recommendationItemsAccordion")
  public myCategoryPanels: MatAccordion;
  public isSubmitted: boolean = false;
  public categories: { name: string; value: number }[];
  public priorities: { name: string; value: number }[] = [
    {
      name: "$admin_recomm_config_item_priority_high",
      value: 1,
    },
    {
      name: "$admin_recomm_config_item_priority_medium",
      value: 2,
    },
    {
      name: "$admin_recomm_config_item_priority_low",
      value: 3,
    },
  ];

  private destroy$: Subject<boolean> = new Subject<boolean>();
  // Inject TranslateService and CookieService
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      languages: SiteSupportedLanguageInterface[];
      recommendation: RecommendationTemplateInterface;
      categories: { name: string; value: number }[];
      cultureCookie: number;
    },
    private _dialogRef: MatDialogRef<RecommendationsConfigurationItemDialogComponent>,
    private _formBuilder: FormBuilder,
    private readonly _snackBar: MatSnackBar,
    private readonly _recommendationService: RecommendationService,
    private _translateService: TranslateService,
    private readonly _httpClient: HttpClient,
    public readonly _defaultStrings: DefaultLanguageStringsService
  ) {
    this.editorConfig = { ...this.editorConfig, height: 130 };
    this.dropzoneConfig = {
      ...this.dropzoneConfig,
      url: "api/recommendation/image",
    };
  }

  public ngOnInit(): void {
    if (!this.data.categories) {
      this._dialogRef.close();
      return;
    }
    this.initializeFormControls();

    // to get language data
    this.supportedlanguage = this.data.languages.filter(
      (list: SiteSupportedLanguageInterface) => {
        if (list.isDefault) {
          this.defaultLanguage = list.languageId;
          this.defLangExt = list.culture;
        }
        if (list.isSupported) {
          return list;
        }
      }
    );
    this.configureForm();
    this._recommendationService
      .getAssessmentQuestionData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((questionData: AssessmentQuestionDataInterface) => {
        if (!questionData) {
          return;
        }

        this.ruleData = questionData;
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public openAll(): void {
    this.myCategoryPanels.openAll();
    this.panelOpenState = true;
  }
  public closeAll(): void {
    this.myCategoryPanels.closeAll();
    this.panelOpenState = false;
  }
  public getLanguageeName(id: number): any {
    const name: SiteSupportedLanguageInterface[] =
      this.supportedlanguage.filter((list: SiteSupportedLanguageInterface) => {
        if (list.languageId === id) {
          return list;
        }
      });
    return this._defaultStrings.defaultStringArray[name[0].label];
  }

  public updateStep(index: number): void {
    this.step = index;
  }

  public uploadSuccessful(event: Event): void {
    const imagePath: string = event[1];

    this.recommendation = { ...this.recommendation, imageRef: imagePath };
    this.placeholderImage = imagePath;
    this.showDelete = true;

    if (this.dropzoneRef) {
      this.dropzoneRef.directiveRef.reset();
    }
  }

  public uploadFailed(): void {
    if (this.dropzoneRef) {
      this.dropzoneRef.directiveRef.reset();
    }
  }

  public deleteImage(): void {
    this.deleteImageFile()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.recommendation = {
          ...this.recommendation,
          imageRef: undefined,
        };
        this.placeholderImage = this.defaultPlaceHolder;
        this.showDelete = false;
        this.saveRecommendation();
      });
  }

  public saveOnStep(event: any): void {
    this.isSubmitted = false;
    if (this.recommendation.id > 0) {
      if (event.selectedIndex !== 0) {
        this.saveRecommendation();
      }
      this.secondStepEnabled = true;
      this.thirdStepEnabled = true;
    }
  }

  public saveRecommendation(): void {
    if (!this.firstFormGroup.valid) {
      this.mceValid = this.firstFormGroup.get("tinyMceControl").valid;
      return;
    }
    this.isLiner = false;
    this.secondStepEnabled = true;
    this.thirdStepEnabled = true;
    let recommendationItemMultiLanguage: recommendationItemMullangInterface[];
    if (!this.addNewItem) {
      if (
        this.recommendation.id > 0 &&
        this.recommendation.recommendationItemsMullang
      ) {
        /* Update Training Item */
        let flag: number = 0;
        recommendationItemMultiLanguage =
          this.recommendation.recommendationItemsMullang.map(
            (multiLanguageItem: recommendationItemMullangInterface) => {
              if (this.defaultLanguage === multiLanguageItem.languageId) {
                flag = 1;
                return {
                  ...multiLanguageItem,
                  title: this.firstFormGroup.get("itemTitleControl").value,
                  text: stringEncodeToB64(
                    this.firstFormGroup.get("tinyMceControl").value
                  ),
                };
              }
              return multiLanguageItem;
            }
          );
        if (flag === 0) {
          recommendationItemMultiLanguage.push({
            title: this.firstFormGroup.get("itemTitleControl").value,
            text: stringEncodeToB64(
              this.firstFormGroup.get("tinyMceControl").value
            ),
            languageId: this.defaultLanguage,
          });
        }
      } else {
        // Create new Training Item
        recommendationItemMultiLanguage = [
          {
            title: this.firstFormGroup.get("itemTitleControl").value,
            text: stringEncodeToB64(
              this.firstFormGroup.get("tinyMceControl").value
            ),
            languageId: this.defaultLanguage,
          },
        ];
      }
    } else {
      // Create new Training Item
      recommendationItemMultiLanguage = [
        {
          title: this.firstFormGroup.get("itemTitleControl").value,
          text: stringEncodeToB64(
            this.firstFormGroup.get("tinyMceControl").value
          ),
          languageId: this.defaultLanguage,
        },
      ];
    }
    this.recommendation = {
      ...this.recommendation,
      category: this.firstFormGroup.get("categoryControl").value,
      priority: this.firstFormGroup.get("priorityControl").value,
      text: stringDecodeToHtml(this.firstFormGroup.get("tinyMceControl").value),
      adaImgDescription: this.firstFormGroup.get("adaTextControl").value,
      recommendationItemsMullang: recommendationItemMultiLanguage,
    };
    this.createItemFormGroup();
    if (!this.isSaving) {
      this.isSaving = true;

      // Existing path
      if (this.recommendation.id > 0) {
        this._recommendationService
          .updateTemplate(this.recommendation)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (updatedRecommendation: RecommendationTemplateInterface) => {
              if (!updatedRecommendation) {
                return;
              }
              this.isSaving = false;
              this.recommendation = updatedRecommendation;
              // Static text to Language Variable updated
              this.showSnackBar(
                this._translateService.instant("$message_recomm_saved")
              );
            }
          );
        return;
      }

      // New path
      this._recommendationService
        .createTemplate(this.recommendation)
        .pipe(takeUntil(this.destroy$))
        .subscribe((updatedRecommendation: RecommendationTemplateInterface) => {
          if (!updatedRecommendation) {
            return;
          }
          this.isSaving = false;
          this.addNewItem = false;
          this.recommendation = updatedRecommendation;
          this.secondStepEnabled = true;
          this.createItemFormGroup();
          // Static text to Language Variable updated
          this.showSnackBar(
            this._translateService.instant("$message_recomm_created")
          );
        });
    }
  }

  public deleteItem(): void {
    this._recommendationService
      .deleteTemplate(this.recommendation)
      .pipe(takeUntil(this.destroy$))
      .subscribe((deletedTemplateResult: RecommendationTemplateInterface) => {
        if (!deletedTemplateResult) {
          return;
        }
        // Static text to Language Variable updated
        const name: string = this.getItemName(
          this.recommendation.recommendationItemsMullang
        );
        this.showSnackBar(
          name + this._translateService.instant("$message_delete")
        );
        this._dialogRef.close();
      });
  }

  public saveRule(ruleData: RecommendationTemplateRuleInterface): void {
    if (ruleData && ruleData.id) {
      this._recommendationService
        .updateRuleToTemplate(ruleData, this.recommendation)
        .pipe(takeUntil(this.destroy$))
        .subscribe((updatedRecommendation: RecommendationTemplateInterface) => {
          if (!updatedRecommendation) {
            return;
          }

          this.recommendation = updatedRecommendation;
          // Static text to Language Variable updated
          this.showSnackBar(
            this._translateService.instant("$message_recomm __rule_updated")
          );
        });
      return;
    }

    if (ruleData) {
      this._recommendationService
        .addRuleToTemplate(ruleData, this.recommendation)
        .pipe(takeUntil(this.destroy$))
        .subscribe((updatedRecommendation: RecommendationTemplateInterface) => {
          if (!updatedRecommendation) {
            return;
          }

          this.recommendation = updatedRecommendation;
          // Static text to Language Variable updated
          this.showSnackBar(
            this._translateService.instant("$message_recomm _rule_added")
          );
        });
    }
  }

  public deleteRule(ruleData: RecommendationTemplateRuleInterface): void {
    this._recommendationService
      .deleteRuleFromTemplate(ruleData, this.recommendation)
      .pipe(takeUntil(this.destroy$))
      .subscribe((updatedRecommendation: RecommendationTemplateInterface) => {
        if (!updatedRecommendation) {
          return;
        }

        this.recommendation = updatedRecommendation;
        // Static text to Language Variable updated
        this.showSnackBar(
          this._translateService.instant("$message_recomm_rule_deleted")
        );
      });
  }

  private configureForm(): void {
    this.categories = this.data.categories;
    // if this is new...
    if (!this.data.recommendation || !this.data.recommendation.id) {
      this.placeholderImage = this.defaultPlaceHolder;
      this.showDelete = false;
      if (this.data.recommendation && this.data.recommendation.category) {
        this.recommendation = this.data.recommendation;
        this.firstFormGroup.patchValue({
          categoryControl: this.recommendation.category,
        });
      }
      this.secondStepEnabled = false;
      return;
    }
    let firstFOrmvalues: recommendationItemMullangInterface;

    // otherwise set the form up
    this.recommendation = this.data.recommendation;
    if (this.recommendation.recommendationItemsMullang) {
      this.recommendation.recommendationItemsMullang.map(
        (recommendationItemsMullang: recommendationItemMullangInterface) => {
          if (recommendationItemsMullang.languageId === this.defaultLanguage) {
            firstFOrmvalues = recommendationItemsMullang;
          }
        }
      );
    }
    this.title = firstFOrmvalues ? firstFOrmvalues.title : "";
    this.isLiner = firstFOrmvalues
      ? firstFOrmvalues.title && firstFOrmvalues.text
        ? false
        : true
      : false;
    this.firstFormGroup.patchValue({
      categoryControl: this.recommendation.category,
      itemTitleControl: firstFOrmvalues ? firstFOrmvalues.title : "",
      priorityControl: this.recommendation.priority,
      tinyMceControl: firstFOrmvalues
        ? stringDecodeToHtml(firstFOrmvalues.text)
        : "",
      adaTextControl: this.recommendation.adaImgDescription || "",
    });

    if (this.recommendation.imageRef) {
      this.showDelete = true;
      this.placeholderImage = this.recommendation.imageRef;
    } else {
      this.showDelete = false;
      this.placeholderImage = this.defaultPlaceHolder;
    }
    this.addNewItem = false;
    this.secondStepEnabled = true;
    if (this.supportedlanguage.length > 1 && this.recommendation) {
      this.createItemFormGroup();
    }
  }

  private initializeFormControls(): void {
    this.firstFormGroup = this._formBuilder.group({
      categoryControl: ["", Validators.required],
      itemTitleControl: ["", Validators.required],
      priorityControl: ["", Validators.required],
      tinyMceControl: ["", Validators.required],
      adaTextControl: [""],
    });
    this.addForm = this._formBuilder.group({});
    this.rows = this._formBuilder.array([]);
  }

  private showSnackBar(message: string): void {
    this._snackBar.open(message, undefined, {
      duration: 5000,
    });
  }

  private deleteImageFile(): Observable<any> {
    const parts: string[] = this.recommendation.imageRef.split("/");
    const url: string =
      (this.recommendation && this.recommendation.id > 0
        ? "/api/recommendation/" + this.recommendation.id + "/image/"
        : "/api/recommendation/image/") + parts[parts.length - 1];

    return this._httpClient.delete(url, { observe: "response" }).pipe(
      map((httpResponse: HttpResponse<any>) => {
        return httpResponse.body;
      })
    );
  }

  // to load form data in step3
  private createItemFormGroup(): void {
    this.addForm = this._formBuilder.group({});
    this.rows = this._formBuilder.array([]);

    if (this.recommendation.recommendationItemsMullang) {
      this.supportedlanguage.map(
        (languageList: SiteSupportedLanguageInterface) => {
          let dbData: recommendationItemMullangInterface;
          if (this.recommendation.recommendationItemsMullang) {
            this.recommendation.recommendationItemsMullang.filter(
              (list: recommendationItemMullangInterface) => {
                if (languageList.languageId === list.languageId) {
                  dbData = list;
                }
              }
            );
          }

          const rowData: FormGroup = this._formBuilder.group({
            title: [
              dbData !== undefined ? dbData.title : "",
              Validators.required,
            ],
            text: [
              dbData !== undefined ? stringDecodeToHtml(dbData.text) : "",
              Validators.required,
            ],
            languageId: languageList.languageId,
          });
          this.rows.push(rowData);
        }
      );
      this.addForm.addControl("rows", this.rows);
    }
  }

  public getItemNameByLanguageID(
    multiLanguageItem: recommendationItemMullangInterface[],
    languageId: number
  ): string {
    let name: string;
    multiLanguageItem.map((item: recommendationItemMullangInterface) => {
      if (item.languageId === languageId) {
        name = item.title;
      }
    });
    return name;
  }
  public saveItemMultilan(
    languageId: number,
    row: any,
    isValidation: any
  ): void {
    if (this.rows.value.length === 0) {
      return;
    }
    if (isValidation) {
      this.isSubmitted = true;
      if (row.invalid) {
        return;
      }
    }
    let defaultFilled: boolean = true;
    let validationSuccess: boolean = true;
    this.rows.controls.map((control: FormGroup) => {
      const item: recommendationItemMullangInterface = control.value;
      if (!item.title && item.languageId === this.defaultLanguage) {
        defaultFilled = false;
      } else if (item.languageId === languageId && !item.title) {
        validationSuccess = false;
        control.get("title").setValidators([Validators.required]);
      }
    });
    if (!defaultFilled || !validationSuccess) {
      return;
    }
    const multiItemsList: recommendationItemMullangInterface[] =
      this.rows.value.filter((item: recommendationItemMullangInterface) => {
        if (item.languageId === languageId) {
          return {
            ...item,
            title: item.title,
            text: stringEncodeToB64(item.text),
          };
        }
        // return item;
      });
    this.recommendation = {
      ...this.recommendation,
      recommendationItemsMullang: multiItemsList,
    };
    if (this.recommendation.id > 0) {
      this._recommendationService
        .updateTemplate(this.recommendation)
        .pipe(takeUntil(this.destroy$))
        .subscribe((updatedRecommendation: RecommendationTemplateInterface) => {
          if (!updatedRecommendation) {
            return;
          }
          this.isSaving = false;
          this.recommendation = updatedRecommendation;
          this.data.recommendation = this.recommendation;
          this.configureForm();
          // Static text to Language Variable updated
          this.showSnackBar(
            this._translateService.instant("$message_recomm_saved")
          );
        });
      return;
    }
  }

  public getItemName(
    multiLanguageItem: recommendationItemMullangInterface[]
  ): string {
    let name: string;
    multiLanguageItem.map((item: recommendationItemMullangInterface) => {
      if (item.languageId === this.data.cultureCookie) {
        name = item.title;
      } else if (item.languageId === this.defaultLanguage) {
        name = item.title;
      }
    });
    return name;
  }
}
